import { memo, useMemo } from 'react';
import { View, ViewStyle } from 'react-native';
import { BoxVariantProps } from '../../Box.types';
import useStyle from '../../../../hooks/useStyle';
import { applyGradientStyles } from './BoxOutlineGradient.utils';

function BoxOutlineGradient({
  id,
  children,
  gradient = 'borderAccent',
  borderWidth = 'border-width-025',
  borderRadius = 'radius-200',
  onLayout,
  ...rest
}: BoxVariantProps<'outline-gradient'>) {
  const style = useStyle<ViewStyle>({
    position: 'relative',
    borderRadius,
    ...rest,
  });
  const gradientStyle = useMemo<Record<string, unknown>>(
    () => applyGradientStyles(gradient, borderWidth),
    [gradient, borderWidth],
  );

  return (
    <View id={id} style={style} onLayout={onLayout}>
      <View style={gradientStyle} />
      {children}
    </View>
  );
}

export default memo(BoxOutlineGradient);
